import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { Box, Button, Modal, Stack, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { theme } from "../../../components/Theme";

interface Props {
  show: boolean;
  catalogInvitations?: any;
  onClick: () => void;
  onClose: () => void;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#fff",
  boxShadow: 24,
  width: "500px",
  borderRadius: "32px",
  borderColor: "transparent",
  outline: "none",
  p: "40px",
};

const ConfirmRemoveInvitationModal = ({
  show,
  catalogInvitations,
  onClick,
  onClose,
}: Props) => {
  const { t } = useTranslation();

  if (!catalogInvitations) {
    return;
  }

  const selectedBusiness = catalogInvitations?.account.businesses?.find(
    (business: any) => business.id === catalogInvitations.recipientBusiness
  );

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  const handleClick = () => {
    onClick();
    setShowModal(false);
    onClose();
  };

  const handleClose = () => {
    setShowModal(false);
    onClose();
  };

  return (
    <Modal
      open={showModal}
      style={{
        backgroundColor: "#32383E99",
        backdropFilter: "unset",
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      onClose={handleClose}
    >
      <Box sx={style}>
        <Stack
          direction={"column"}
          sx={{
            alignItems: "center",
            gap: "24px",
          }}
        >
          <ExclamationCircleIcon
            width={64}
            height={64}
            color={theme.palette.others.text_danger}
          />

          {/* prompt */}
          <Stack
            direction={"column"}
            sx={{
              gap: "12px",
              textAlign: "center",
            }}
          >
            <Typography
              level="text-xl2-bold"
              textColor={theme.palette.common.black}
            >
              {t("catalog.shareCatalog.removeAccess.title")}
            </Typography>

            <Typography level="text-md-regular">
              <Trans
                i18nKey="catalog.shareCatalog.removeAccess.prompt"
                values={{
                  companyName: selectedBusiness
                    ? selectedBusiness.companyName
                    : catalogInvitations?.account?.authStrategy === "PHONE_AUTH"
                    ? catalogInvitations?.account?.phoneNumber
                    : catalogInvitations?.account?.email,
                }}
                components={{
                  highlight: <Typography level="text-md-semibold" />,
                }}
              />
            </Typography>
          </Stack>

          {/* buttons */}
          <Stack
            direction={"row"}
            sx={{
              width: "100%",
              gap: "12px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="linkz-outlined-danger"
              onClick={handleClose}
              sx={{ minWidth: "204px" }}
            >
              {t("commons.cancelBtn")}
            </Button>

            <Button
              variant="linkz-filled-danger"
              onClick={handleClick}
              sx={{ minWidth: "204px" }}
            >
              {t("commons.removeBtn")}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ConfirmRemoveInvitationModal;
